import React from "react";
import EditIcon from "static/images/EditIcon";
import DeleteIcon from "static/images/DeleteIcon";
import { t } from "components/CentralDataMangement/translation/Translation";

interface SignatoryTableProps {
    data: any[];
    onEdit: (index: number) => void;
    onDelete: (index: number) => void;
    virtueList: any[];
}

const SignatoryTable: React.FC<SignatoryTableProps> = ({
    data,
    onEdit,
    onDelete,
    virtueList
}) => {

    const getVirtueLabel = (value: any) => {
        if (value === null || value === undefined || value === 0) return '-';
        const virtue = virtueList.find(virtue => virtue.value === value);
        return virtue ? t(virtue.label) : '-';
    };

    if (!data || data.length === 0) {
        return (
            <div className="text-center p-4">
                <p className="text-muted">{t("No signatory details found")}</p>
            </div>
        );
    }

    return (
        <div className="table-responsive scrollBarDesign">
            <table className="table table-hover general-agreement-table mb-0">
                <thead className="sticky-top bg-white">
                    <tr className="TableHeader bg-white">
                        <th className="ps-lg-4" style={{ width: '25%' }}>{t("Name")}</th>
                        <th style={{ width: '25%' }}>{t("Position")}</th>
                        <th style={{ width: '35%' }}>{t("Pursuant")}</th>
                        <th style={{ width: '15%' }}>{t("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item: any, index: number) => (
                        <tr key={index} className="border-bottom align-middle">
                            <td className="text-break ps-lg-4" style={{ width: '25%' }}>
                                {item.name}
                            </td>
                            <td className="text-break" style={{ width: '25%' }}>
                                {item.position || '-'}
                            </td>
                            <td className="text-break" style={{ width: '35%' }}>
                                {getVirtueLabel(item.pursuant)}
                            </td>
                            <td className="table-action-icons" style={{ width: '15%' }}>
                                <button
                                    type="button"
                                    onClick={() => onEdit(index)}
                                    className="bg-transparent border-0 shadow-none me-2"
                                    title={t("Edit")}
                                >
                                    <EditIcon />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => onDelete(index)}
                                    className="bg-transparent border-0 shadow-none"
                                    title={t("Delete")}
                                >
                                    <DeleteIcon />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SignatoryTable;